import { Component, OnInit, HostBinding, Optional } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ProcessDefinition } from '../../entity/processdefinition';
import { BehaviorSubject } from 'rxjs';
import { MessagerService } from '@farris/ui-messager';
import { I18nService } from '../../runtime/services/i18n.service';

@Component({
  selector: 'wf-process-selector',
  templateUrl: './process-selector.component.html',
  styleUrls: ['./process-selector.component.css']
})
export class ProcessSelectorComponent implements OnInit {
  @HostBinding('class')
  cls = 'farris-main-area flex-column';

  gridData: ProcessDefinition[];
  columns = [
    { title: this.i18nService ? this.i18nService.getValue('static.columnName.prcessName') : '流程名称', field: 'procDefName', width: 200 },
    { title: this.i18nService ? this.i18nService.getValue('static.columnName.version') : '版本', field: 'version', width: 100 }];
  idField = 'procDefId';
  mySelection: string[] = [];

  private subject = new Subject<string>();
  constructor(
    private msgService: MessagerService,
    @Optional() private i18nService: I18nService
    ) {
  }

  ngOnInit() {
  }

  btnOKClick() {
    if (this.mySelection.length < 1) {
      this.msgService.warning(this.i18nService ? this.i18nService.getValue('static.submit.noProcess') : '尚未选择流程定义，请了解。');
      return;
    }
    this.subject.next(this.mySelection[0]);
  }
  btnCancelClick() {
    this.subject.next(null);
  }

  subscribe(): Observable<string> {
    return this.subject.asObservable();
  }

  onSelectionChange(data) {
    if (data && data.data) {
      this.mySelection = [data.data.procDefId];
    } else {
      this.mySelection = [];
    }
  }

}
